import styled from "styled-components";

export const LeaderboardContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .content_section {
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    min-height: calc(100vh - 235px);
    border-radius: 8px;
    padding: 32px 40px;
  }

  .loading_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .header_area {
    margin-bottom: 24px;
  }

  .section_label {
    margin-bottom: 16px;

    .label_th {
      font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
      display: block;
    }

    .label_en {
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      color: ${({ theme }) => theme.COLORS.GRAY_26};
      display: block;
      margin-top: 2px;
    }
  }

  .name_cell {
    padding: 0 6px;
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }

  .pagination_section {
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    border-radius: 8px;
  }
`;
